import { render, staticRenderFns } from "./RegisterFormGeneral.vue?vue&type=template&id=def5d97c&scoped=true"
import script from "./RegisterFormGeneral.vue?vue&type=script&lang=js"
export * from "./RegisterFormGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5d97c",
  null
  
)

export default component.exports